<button type="button" [title]="title" [attr.disabled]="disabled?'':null"
    (click)="onClick($event)" (contextmenu)="onContextmenu($event)" i18n="@@RegisterIC"
    class="rect-btn" [ngClass]="btnCls" #btn>

    <mat-icon [ngClass]="iconCls" class="vis-combine-icon">{{icon}}</mat-icon>
    <ng-content></ng-content>
</button>
